import React, { Component } from 'react';
import Page from '@acri-tools/react-tools/components/Page/Page';
import { PrivacySettings } from '@acri-tools/gdpr-library';
import { bannerImage } from '../../theme/images';
import routes from '../../utils/routes';
import Footer from '../../components/Footer/Footer';
import { GDPR_PATH } from '../../gdpr/setup';
import '../Gdpr/Gdpr.css';

export default class PrivacySettingsPage extends Component {
    render() {
        return (
            <Page
                id="privacy-settings"
                footer={<Footer />}
                banner={{
                    bannerImage: bannerImage,
                    topBar: {
                        routes: routes,
                        disableLogo: true,
                    },
                }}
            >
                <div className="page-content gdpr-page">
                    <PrivacySettings privacyPoliciesPath={GDPR_PATH} />
                </div>
            </Page>
        );
    }
}
